import { createScript } from './createScript';

export const useCaptcha = settings => {
  const { cfCaptchaAccountPhoneVerification, cfCaptchaDiscountPhoneVerification, cfCaptchaPointsRedeem } = settings;

  const validateCaptcha = (enabled, siteKey) => {
    if (enabled && siteKey) {
      return new Promise((resolve, reject) => {
        try {
          window.turnstile.render('.cf-turnstile', {
            sitekey: siteKey,
            callback: token => {
              resolve(token);
            },
          });
        } catch (e) {
          reject(e.message);
        }
      });
    }

    return null;
  };

  const addCaptchaScript = (enabled, siteKey) => {
    if (enabled && siteKey) {
      createScript(
        'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=validateCaptcha',
        true,
        true
      );
    }
  };

  return {
    validateCaptcha,
    addCaptchaScript,
    cfCaptchaDiscountPhoneVerification,
    cfCaptchaAccountPhoneVerification,
    cfCaptchaPointsRedeem,
  };
};
